import React from 'react';
import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import ImageListOfEmployees from '../../assets/images/list-of-emoloyees.png';
import ImageTrasnferOfMgt from '../../assets/images/transfer-of-mgt.png';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SalaryEntry: React.FC = () => {
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const type = searchParams[0].get('type');
  const handleNavigateEmpList = () => {
    if (type === 'new') {
      navigate(`/paystub-employee-list`);
    } else {
      navigate(`/salary-specification-emp-list`);
    }
  };

  const handleNavigateTransferOfMgt = () => {
    if (type === 'new') {
      navigate(`/paystub-send-management`);
    } else {
      navigate(`/salary-specification-transfer-of-mgt`);
    }
  };

  return (
    <WithSideBarAndNavBar>
      <div className="flex h-full flex-col">
        <div className="font-['Spoqa_Han_Sans_Neo'] text-[28px] font-bold leading-[38px] text-[#333333]">
          급여명세서
        </div>

        <div className="flex flex-1 items-center justify-center">
          <button className="cursor-pointer" onClick={handleNavigateEmpList}>
            <img src={ImageListOfEmployees} alt="list-of-employees" />
          </button>
          <button className="cursor-pointer" onClick={handleNavigateTransferOfMgt}>
            <img src={ImageTrasnferOfMgt} alt="transfer-of-mgt" />
          </button>
        </div>
      </div>
    </WithSideBarAndNavBar>
  );
};

export default SalaryEntry;
